import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Clarity from "@microsoft/clarity";
import { FEATURE_FLAGS } from "config/feature-flags";
import { getUser } from "store/selector";
import { getPersonalInfo } from "view/profile/store/selector";
import { trackPageView, identifyUser } from "utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const { userId, username } = useSelector(getUser);
  const personalInfo = useSelector(getPersonalInfo);

  useEffect(() => {
    // Initialize Clarity
    if (
      FEATURE_FLAGS.ENABLE_CLARITY &&
      process.env.REACT_APP_CLARITY_PROJECT_ID
    ) {
      Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const userProps = { username };
      if (personalInfo?.iAm) {
        userProps.gender = personalInfo.iAm;
      }
      identifyUser(userId, userProps);

      // Identify user in Clarity
      if (FEATURE_FLAGS.ENABLE_CLARITY) {
        Clarity.identify(userId, null, null, username);
      }
      // Note: identify signature is (customId, customSessionId, customPageId, friendlyName)
      // I am mapping userId -> customId and username -> friendlyName
    }
  }, [userId, username, personalInfo?.iAm]);

  useEffect(() => {
    // Track Page View
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
